import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Box
} from '@mui/material'

const DialougeBox = ({
  status,
  onClose,
  message,
  operation,
  operation1,
  title
}) => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        {status && status === 'error'
          ? title || 'Oops! An Error Occurred'
          : status && status === 'warning'
          ? title || 'Warning: Check Your Action'
          : status && status === 'info'
          ? title || 'Information: Check Your Action'
          : status && status === 'success'
          ? title || 'Action Completed Successfully'
          : title}
      </DialogTitle>
      <DialogContent id='alert-dialog-description'>
        {(status && (
          <Alert severity={status}>
            <Box sx={{ whiteSpace: 'pre-wrap' }}>{message}</Box>
          </Alert>
        )) ||
          message}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        {operation && (
          <Button
            onClick={
              typeof operation?.functionality === 'function'
                ? operation.functionality
                : operation
            }
            variant='contained'
            color='success'
          >
            {operation.title || 'Yes'}
          </Button>
        )}
        {operation1 && (
          <Button
            onClick={
              typeof operation1?.functionality === 'function'
                ? operation1.functionality
                : operation1
            }
            variant='contained'
            color='secondary'
          >
            {operation1.title || 'Yes'}
          </Button>
        )}
        <Button onClick={onClose} color='error' variant='contained'>
          {(operation && 'Cancel') || 'Close'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialougeBox
